import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnInit } from '@angular/core';
import { CoreService } from '@app/modules/core/services/core.service';
import { SocialHelper } from '@app/store/models/social-helper.interface';
import { FunctionsService } from '@app/modules/core/services/functions.service';
import { UserQrGeneratorService } from '@app/modules/user/services/user-qr-generator.service';
import { QrGeneratorNavigatorPET, DynamicQrPageThemeType, SupportedLanguage } from 'shared-library';

declare var PhotoSwipe: any
declare var PhotoSwipeUI_Default: any

@Component({
  selector: 'app-qrs-pet',
  templateUrl: './qrs-pet.component.html',
  styleUrls: [
    './qrs-pet.component.scss',
    './qrs-pet-ThemeType1.component.scss',
    './qrs-pet-ThemeType2.component.scss',
    './qrs-pet-ThemeType3.component.scss',
    './qrs-pet-ThemeType4.component.scss',
    './qrs-pet-ThemeType5.component.scss',
    './qrs-pet-ThemeType6.component.scss',
    './qrs-pet-ThemeType7.component.scss',
    './qrs-pet-ThemeType8.component.scss',
    './qrs-pet-ThemeType9.component.scss',
    './qrs-pet-ThemeType11.component.scss',
    './qrs-pet-ThemeType12.component.scss',
    '../qrs-wrapper.component.scss'
  ]
})
export class QrsPetComponent implements OnInit {

  submitting = false
  @Input() qr_url: string;
  @Input() short_id: string;
  @Input() social_data: SocialHelper
  @Input() data: QrGeneratorNavigatorPET

  ThemeTypes = {
    ThemeType1: DynamicQrPageThemeType.ThemeType1,
    ThemeType2: DynamicQrPageThemeType.ThemeType2,
    ThemeType3: DynamicQrPageThemeType.ThemeType3,
    ThemeType4: DynamicQrPageThemeType.ThemeType4,
    ThemeType5: DynamicQrPageThemeType.ThemeType5,
    ThemeType6: DynamicQrPageThemeType.ThemeType6,
    ThemeType7: DynamicQrPageThemeType.ThemeType7,
    ThemeType8: DynamicQrPageThemeType.ThemeType8,
    ThemeType9: DynamicQrPageThemeType.ThemeType9,
    ThemeType10: DynamicQrPageThemeType.ThemeType10,
    ThemeType11: DynamicQrPageThemeType.ThemeType11,
    ThemeType12: DynamicQrPageThemeType.ThemeType12,
  }

  constructor(
    public readonly coreService: CoreService,
    public translateService: TranslateService,
    public readonly functionService: FunctionsService,
    public qrGeneratorService: UserQrGeneratorService
  ) {
  }

  ngOnInit(): void {
    if (!this.short_id) {
      throw new Error("Short id is required");
    }
    this.translateService.use(this.data.language?.default || SupportedLanguage.English);
    this.functionService.initializeTooltip()
    this.deepAddStyleToQuillOutput()
    setTimeout(() => {
      this.initPhotoSwipe()
    }, 500)
  }

  private deepAddStyleToQuillOutput() {
    setTimeout(() => {
      const tempDiv = document.getElementById('ql-editor')
      if (tempDiv) {
        let textAlign = [
          DynamicQrPageThemeType.ThemeType3,
          DynamicQrPageThemeType.ThemeType4,
          DynamicQrPageThemeType.ThemeType9,
          DynamicQrPageThemeType.ThemeType10,
        ].includes(this.data.theme.type) ? 'left' : 'center';
        const color = [
          DynamicQrPageThemeType.ThemeType1,
          DynamicQrPageThemeType.ThemeType3,
          DynamicQrPageThemeType.ThemeType4,
          DynamicQrPageThemeType.ThemeType5,
          DynamicQrPageThemeType.ThemeType6,
          DynamicQrPageThemeType.ThemeType8,
          DynamicQrPageThemeType.ThemeType11,
          DynamicQrPageThemeType.ThemeType12,
        ].includes(this.data.theme.type) ? this.data.colors.primary_color : this.data.colors.text_color;

        tempDiv.childNodes.forEach((node: HTMLElement) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const parentEl = node.parentNode as HTMLElement;
            parentEl.style.textAlign = textAlign;
            parentEl.style.color = color;
          } else {
            node.style.textAlign = textAlign;
            node.style.color = color;
          }
        });
      }
    })
  }

  sendLocation() {
    if (this.submitting) return
    if (!navigator.geolocation) {
      this.functionService.showErrorMessage('Missing support for geolocation')
      return
    }
    navigator.geolocation.getCurrentPosition((position) => {
      if (position) {
        this.sendGeoLocation(position.coords.longitude, position.coords.latitude)
      } else {
        this.functionService.showErrorMessage('Error getting current location')
      }
    },
      (error) => this.functionService.showErrorMessage(error?.message || 'Permission denied to get current location'));
  }

  private async sendGeoLocation(longitude: number, latitude: number) {
    this.submitting = true
    try {
      await this.coreService.submitQRResponses(this.short_id, {
        longitude, latitude
      })
      this.functionService.showSuccessMessage('Location sent')
    } catch (error) {
    }
    this.submitting = false
  }

  initPhotoSwipe() {
    var initPhotoSwipeFromDOM = async (gallerySelector: string) => {

      var parseThumbnailElements = async (el: any) => {
        var thumbElements = el.childNodes,
          numNodes = thumbElements.length,
          items = [],
          figureEl,
          linkEl,
          size,
          item;

        for (var i = 0; i < numNodes; i++) {

          figureEl = thumbElements[i]; // <figure> element

          // include only element nodes
          if (figureEl.nodeType !== 1) {
            continue;
          }

          linkEl = figureEl.children[0]; // <a> element

          size = linkEl.getAttribute('data-size') ? linkEl.getAttribute('data-size').split('x') : null;

          if (!size) {
            const getMeta = async (url: string): Promise<number[]> => {
              return new Promise((y, n) => {
                var img = new Image();
                img.addEventListener("load", function () {
                  y([this.naturalWidth, this.naturalHeight])
                });
                img.src = url;
              })
            }
            size = await getMeta(linkEl.getAttribute("href"))
          }

          // create slide object
          item = {
            src: linkEl.getAttribute('href'),
            w: parseInt(size[0], 10),
            h: parseInt(size[1], 10)
          };



          if (figureEl.children.length > 1) {
            // <figcaption> content
            item.title = figureEl.children[1].innerHTML;
          }

          if (linkEl.children.length > 0) {
            // <img> thumbnail element, retrieving thumbnail url
            item.msrc = linkEl.children[0].getAttribute('src');
          }

          item.el = figureEl; // save link to element for getThumbBoundsFn
          items.push(item);
        }

        return items;
      };

      // find nearest parent element
      var closest = function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
      };

      // triggers when user clicks on thumbnail
      var onThumbnailsClick = function (e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        var eTarget = e.target || e.srcElement;
        // find root element of slide
        var clickedListItem = closest(eTarget, function (el) {
          return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
        });

        if (!clickedListItem) {
          return null;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        var clickedGallery = clickedListItem.parentNode,
          childNodes = clickedListItem.parentNode.childNodes,
          numChildNodes = childNodes.length,
          nodeIndex = 0,
          index;

        for (var i = 0; i < numChildNodes; i++) {
          if (childNodes[i].nodeType !== 1) {
            continue;
          }

          if (childNodes[i] === clickedListItem) {
            index = nodeIndex;
            break;
          }
          nodeIndex++;
        }



        if (index >= 0) {
          // open PhotoSwipe if valid index found
          openPhotoSwipe(index, clickedGallery);
        }
        return false;
      };

      // parse picture index and gallery index from URL (#&pid=1&gid=2)
      var photoswipeParseHash = function () {
        var hash = window.location.hash.substring(1),
          params: any = {};

        if (hash.length < 5) {
          return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
          if (!vars[i]) {
            continue;
          }
          var pair = vars[i].split('=');
          if (pair.length < 2) {
            continue;
          }
          params[pair[0]] = pair[1];
        }

        if (params.gid) {
          params.gid = parseInt(params.gid, 10);
        }

        return params;
      };

      var openPhotoSwipe = async (index, galleryElement, disableAnimation = false, fromURL = false) => {
        var pswpElement = document.querySelectorAll('.pswp')[0],
          gallery,
          options,
          items;

        items = await parseThumbnailElements(galleryElement);

        // define options (if needed)
        options = {

          // define gallery index (for URL)
          galleryUID: galleryElement.getAttribute('data-pswp-uid'),

          getThumbBoundsFn: function (index) {
            // See Options -> getThumbBoundsFn section of documentation for more info
            var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
              pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect();

            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          }

        };

        // PhotoSwipe opened from URL
        if (fromURL) {
          if (options.galleryPIDs) {
            // parse real index when custom PIDs are used
            // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
            for (var j = 0; j < items.length; j++) {
              if (items[j].pid == index) {
                options.index = j;
                break;
              }
            }
          } else {
            // in URL indexes start from 1
            options.index = parseInt(index, 10) - 1;
          }
        } else {
          options.index = parseInt(index, 10);
        }

        // exit if index not found
        if (isNaN(options.index)) {
          return;
        }

        if (disableAnimation) {
          options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
      };

      // loop through all gallery elements and bind events
      var galleryElements: any = document.querySelectorAll(gallerySelector);
      for (var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', (i + 1).toString());
        galleryElements[i].onclick = onThumbnailsClick;
      }

      // Parse URL and open gallery if it contains #&pid=3&gid=1
      var hashData = photoswipeParseHash();
      if (hashData.pid && hashData.gid) {
        await openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
      }
    };

    // execute above function
    initPhotoSwipeFromDOM('.media-gallery');
  }
}
